export function jumpToAnchor(event, href) {
  if (!href?.startsWith('#')) return;
  const element = document.getElementById(href.slice(1));
  if (!element) return;

  event.preventDefault();
  const top = element.getBoundingClientRect().top + window.scrollY - 84;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  window.history.replaceState(null, '', href);
}
